import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

const contactInfo = [
  {
    icon: 'fa-map-marker-alt',
    title: 'Visitanos',
    content: 'L. N. Alem 1060, Burzaco',
    subContent: 'CP1852, Buenos Aires',
    action: 'https://maps.app.goo.gl/vYnRkyRD7JJWQRBfA'
  },
  {
    icon: 'fa-phone-alt',
    title: 'Llamanos',
    content: '+54 11 6157-3380',
    subContent: 'Lun - Vie: 9:00 - 18:00',
    action: 'tel:+5491161573380'
  },
  {
    icon: 'fa-envelope',
    title: 'Escribinos',
    content: 'Organizacionram.asegurados@gmail.com',
    subContent: 'Respuesta en 24hs',
    action: 'mailto:Organizacionram.asegurados@gmail.com'
  }
];

const socialLinks = [
  { icon: 'fa-instagram', href: 'https://www.instagram.com/organizacionram.625/', label: 'Instagram' },
  { icon: 'fa-facebook-f', href: '#', label: 'Facebook' },
  { icon: 'fa-whatsapp', href: 'https://wa.me/5491161573380', label: 'WhatsApp' },
];

export const Contact = ({ onCotizarClick }) => {
  return (
    <section id="contacto" className="py-24 bg-gradient-subtle">
      <div className="container mx-auto px-4 md:px-6">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center gap-2 bg-primary/10 px-4 py-2 rounded-full mb-4">
            <i className="fas fa-map-marker-alt text-primary"></i>
            <span className="text-sm font-medium text-primary">Contacto</span>
          </div>
          
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Visitanos en{' '}
            <span className="text-primary">Burzaco</span>
          </h2>
          
          <p className="text-muted-foreground text-lg">
            Estamos para ayudarte. Contactanos por el medio que prefieras o visitá nuestra oficina.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Map */}
          <div className="rounded-3xl overflow-hidden shadow-xl h-[400px] lg:h-full min-h-[400px]">
            <iframe 
              src="https://www.google.com/maps?q=-34.8305653,-58.3871316&z=17&output=embed"
              width="100%" 
              height="100%" 
              style={{ border: 0 }} 
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
              title="Ubicación Organizacion Ram - L. N. Alem 1060, Burzaco"
            ></iframe>
          </div>

          {/* Contact Info */}
          <div className="space-y-6">
            {/* Contact Cards */}
            {contactInfo.map((info, index) => (
              <Card key={index} className="card-hover border-0 bg-card">
                <CardContent className="p-6">
                  <div className="flex items-start gap-5">
                    <div className="w-14 h-14 bg-primary/10 rounded-2xl flex items-center justify-center flex-shrink-0">
                      <i className={`fas ${info.icon} text-2xl text-primary`}></i>
                    </div>
                    <div className="flex-grow">
                      <h4 className="font-semibold text-foreground text-lg mb-1">{info.title}</h4>
                      {info.action ? (
                        <a 
                          href={info.action} 
                          target={info.action.startsWith('http') ? '_blank' : undefined}
                          rel={info.action.startsWith('http') ? 'noopener noreferrer' : undefined}
                          className="text-muted-foreground hover:text-primary transition-colors"
                        >
                          {info.content}
                        </a>
                      ) : (
                        <p className="text-muted-foreground">{info.content}</p>
                      )}
                      <p className="text-sm text-muted-foreground/70 mt-1">{info.subContent}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}

            {/* Horarios */}
            <Card className="border-0 bg-card">
              <CardContent className="p-6">
                <div className="flex items-start gap-5">
                  <div className="w-14 h-14 bg-primary/10 rounded-2xl flex items-center justify-center flex-shrink-0">
                    <i className="fas fa-clock text-2xl text-primary"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-foreground text-lg mb-3">Horarios de Atención</h4>
                    <div className="space-y-2 text-muted-foreground">
                      <div className="flex justify-between gap-8">
                        <span>Lunes - Viernes</span>
                        <span className="font-medium text-foreground">9:00 - 18:00</span>
                      </div>
                      <div className="flex justify-between gap-8">
                        <span>Sábados</span>
                        <span className="font-medium text-foreground">9:00 - 13:00</span>
                      </div>
                      <div className="flex justify-between gap-8">
                        <span>Domingos</span>
                        <span className="text-muted-foreground/70">Cerrado</span>
                      </div>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* WhatsApp CTA */}
            <Button 
              onClick={() => window.open('https://wa.me/5491161573380?text=Hola!%20Me%20gustaría%20recibir%20información%20sobre%20seguros.', '_blank')}
              size="lg"
              className="w-full bg-success text-success-foreground hover:bg-success/90 font-bold py-6 rounded-full shadow-lg"
            >
              <i className="fab fa-whatsapp text-xl mr-3"></i>
              Contactar por WhatsApp
            </Button>

            {/* Social Links */}
            <div className="flex items-center justify-center gap-4 pt-4">
              <span className="text-muted-foreground text-sm">Seguinos en:</span>
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-muted rounded-full flex items-center justify-center text-muted-foreground hover:bg-primary hover:text-primary-foreground transition-all duration-300"
                  aria-label={social.label}
                >
                  <i className={`fab ${social.icon}`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
